import { BaseInputFieldFilter, FilterLabelProps } from "@duosoftbg/nacid-components";
import React from "react";

const RecipientsFilter = ({ label = "l.searchFilter.recipients", ...others }: FilterLabelProps) => {
  return <BaseInputFieldFilter label={label} fieldName={"recipients"} {...others} />;
};

export default RecipientsFilter;
